<template>
	<div>
		<el-row class="contents">
			<!-- 列表 -->
			<el-col style="width: 500px;">
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>编辑菜单</span>
					</div>
					<!-- 查询条件 -->
					<el-col :span="24">
						<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="80px" style="margin: 0px;" label-suffix=":">
							<el-row>
								<el-form-item label="客户端" style="margin-bottom: 10px;">
									<el-radio-group v-model="queryParams.source" size="small" @change="handleQueryTree">
										<el-radio label="web">后台</el-radio>
										<el-radio label="app">安卓</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-row>
						</el-form>
					</el-col>
					<el-col :span="24">
						<el-tree :data="data" node-key="id" default-expand-all :expand-on-click-node="false" @node-drop="handleDrop" draggable v-loading="treeLoading">
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span>
									<!-- <i :class="data.icon" v-if="data.icon"></i> -->
									<i class="el-icon-switch-button" v-if="data.type=='btn'"></i>
									<i class="el-icon-folder-opened" v-else-if="data.children"></i>
									<i class="el-icon-document" v-else></i>
									{{ node.label }}
									<el-button type="text" size="mini" @click="() => handleEdit(data)">
										<i class="el-icon-edit" title="编辑"></i>
									</el-button>
								</span>
								<span>
									<el-button type="text" size="mini" @click="() => append(data)" v-if="data.type=='page'">
										<i class="el-icon-plus" title="添加子节点"></i>
									</el-button>
									<el-button type="text" size="mini" @click="() => insert(data,true)">
										<i class="el-icon-upload2" title="向前插入节点"></i>
									</el-button>
									<el-button type="text" size="mini" @click="() => insert(data,false)">
										<i class="el-icon-download" title="向后插入节点"></i>
									</el-button>
									<el-button type="text" size="mini" @click="() => remove(node, data)">
										<i class="el-icon-delete" title="删除节点"></i>
									</el-button>
								</span>
							</span>
						</el-tree>
					</el-col>
				</el-card>
			</el-col>
			<el-col style="margin-left: 100px;width:400px">
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>预览菜单</span>
						 <el-button style="float: right; padding: 3px 0" type="text" @click="handlePreviewQueryTree">刷新</el-button>
					</div>
					<!-- 查询条件 -->
					<el-col :span="24">
						<el-form :inline="true" :model="previewParams" class="form" size="small" label-width="80px" style="margin: 0px;" label-suffix=":">
							<el-row>
								<el-form-item label="客户端" style="margin-bottom: 10px;">
									<el-radio-group v-model="previewParams.source" size="small" @change="handlePreviewQueryTree">
										<el-radio label="web">后台</el-radio>
										<el-radio label="app">安卓</el-radio>
									</el-radio-group>
								</el-form-item>
								<el-form-item label="业务范围" style="margin-bottom: 10px;">
									<el-radio-group v-model="previewParams.business" size="small" @change="handlePreviewQueryTree">
										<el-radio label="平台">平台</el-radio>
										<el-radio label="机构">机构</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-row>
							
						</el-form>
					</el-col>
					<el-col :span="24">
						<el-tree :data="previewData" node-key="id" default-expand-all :expand-on-click-node="false" v-loading="previewTreeLoading">
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span>
									<i :class="data.icon" v-if="data.icon"></i>
									<i class="el-icon-switch-button" v-if="data.type=='btn'"></i>
									{{ node.label }}
								</span>
							</span>
						</el-tree>
					</el-col>
				</el-card>
			</el-col>
		</el-row>

		<!-- 添加/修改 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
			<el-form :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="80px">
				<el-form-item label="类型">
					<el-radio-group v-model="addOrUpdateForm.type" size="small">
						<el-radio label="page">页面</el-radio>
						<el-radio label="btn">按钮</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="菜单标题" prop="label" v-if="addOrUpdateForm.type=='page'">
					<el-input type="text" v-model="addOrUpdateForm.label"></el-input>
				</el-form-item>
				<el-form-item label="按钮标题" prop="label" v-else>
					<el-input type="text" v-model="addOrUpdateForm.label"></el-input>
				</el-form-item>
				<el-form-item label="菜单显示" prop="isShow" v-if="addOrUpdateForm.type=='page'">
					<el-radio-group v-model="addOrUpdateForm.isShow" size="small">
						<el-radio :label="1">显示</el-radio>
						<el-radio :label="0">隐藏</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="菜单code" prop="code" v-if="addOrUpdateForm.type=='page'">
					<el-input type="text" v-model="addOrUpdateForm.code"></el-input>
				</el-form-item>
				<el-form-item label="按钮code" prop="code" v-else>
					<el-input type="text" v-model="addOrUpdateForm.code"></el-input>
				</el-form-item>
				<el-form-item label="跳转地址" v-if="addOrUpdateForm.type=='page'">
					<el-input v-model="addOrUpdateForm.perUrl"></el-input>
				</el-form-item>
				<el-form-item label="图标" v-if="addOrUpdateForm.type=='page'">
					<el-input v-model="addOrUpdateForm.icon"></el-input>
				</el-form-item>
				<el-form-item label="业务场景" prop="businessArray">
					<el-checkbox-group v-model="addOrUpdateForm.businessArray">
						<el-checkbox-button label="技术">技术</el-checkbox-button>
						<el-checkbox-button label="平台">平台</el-checkbox-button>
						<el-checkbox-button label="机构">机构</el-checkbox-button>
					</el-checkbox-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdate">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front.vue'

	export default {
		extends: BaseSearch,
		data() {
			return {
				id: 1000,
				parentMenus: [],
				url: "menus",
				name: "菜单",
				autoQuery: false,
				queryParams: {
					source: 'web',
				},
				previewParams: {
					source: 'web',
					business: "平台"
				},
				previewTreeLoading:true,
				previewData:[],
				lastBusiness: ["平台", "机构"],
				treeLoading: true,
				rules: {
					label: [{
						required: true,
						message: '菜单标题不能为空',
						trigger: 'change'
					}],
					isShow: [{
						required: true,
						message: '菜单显示不能为空',
						trigger: 'change'
					}],
					businessArray: [{
						type: 'array',
						required: true,
						message: '业务场景不能为空',
						trigger: 'change'
					}]
				},
				data: [],
				selectNode: {}
			};
		},
		methods: {
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					newObj.businessArray = newObj.business.toString().split(",");
					this.addOrUpdateForm = newObj;
				} else {
					this.addOrUpdateForm = {
						businessArray: ['平台'],
						type: "page",
						code: '',
						label: '',
						orderBy: '',
						icon: '',
						perUrl: '',
						business: '平台',
						isShow:1
					};
				}
			},
			checkboxChange(value) {
				if (value.length > 0) {
					this.lastBusiness = value
					this.handleQueryTree()
				} else {
					this.queryParams.business = this.lastBusiness;
				}

			},
			handleQueryTree() {
				let that = this;
				this.treeLoading = true
				this.$http({
					method: 'POST',
					url: 'menus/query/tree',
					data: this.queryParams,
				}).then(function(res) {
					if (res.data.errorCode == '0000') {
						that.fillParent({
							children: res.data.data
						}, res.data.data)
						that.data = res.data.data;
						that.flushOrderBy()
					}
					that.treeLoading = false
				})
			},
			handlePreviewQueryTree() {
				let that = this;
				this.previewTreeLoading = true
				this.$http({
					method: 'POST',
					url: 'menus/query/tree',
					data: this.previewParams,
				}).then(function(res) {
					if (res.data.errorCode == '0000') {
						that.previewData = res.data.data;
					}
					that.previewTreeLoading = false
				})
			},
			fillParent(parent, datas) {
				if (datas) {
					datas.forEach(item => {
						item.parent = parent
						this.fillParent(item, item.children)
					})
				}
			},
			handleQueryParent() { //查询父级分类
				let that = this;
				this.$http({
					method: 'POST',
					url: 'menus/queryParent',
					data: {},
				}).then(function(res) {
					if (res.data.errorCode == '0000') {
						that.parentMenus = res.data.data;
					}
				})
			},
			beforeEdit(isEdit, data) {
				if (data) {
					this.selectNode = data
				}
				if(this.addOrUpdateForm.type!='page'){
					this.addOrUpdateForm.isShow=1
				}
				this.addOrUpdateForm.source = this.queryParams.source
			},
			append(data) {
				this.selectNode = data
				var maxId = 0
				if (data.children) {
					data.children.forEach(item => {
						if (item.orderBy > maxId) {
							maxId = item.orderBy
						}
					})
				}
				this.handleAdd()
				if (data.parent.id) {
					this.addOrUpdateForm.type = "btn"
					this.addOrUpdateForm.code = "btn_"
				}
				this.addOrUpdateForm.parentId = data.id
				this.addOrUpdateForm.orderBy = maxId + 1
				if (this.selectNode.children) {
					this.addOrUpdateForm.index = this.selectNode.children.length
				} else {
					this.addOrUpdateForm.index = 1
				}

			},
			insert(data, isBefore) {
				this.selectNode = data
				this.handleAdd()
				if (data.type == 'btn') {
					this.addOrUpdateForm.type = "btn"
					this.addOrUpdateForm.code = "btn_"
				}
				if (isBefore) {
					this.addOrUpdateForm.orderBy = this.selectNode.orderBy - 1
				} else {
					this.addOrUpdateForm.orderBy = this.selectNode.orderBy + 1
				}
				this.addOrUpdateForm.parentId = this.selectNode.parent.id
				const index = data.parent.children.findIndex(d => d.id === data.id);
				if (isBefore) {
					this.addOrUpdateForm.index = index
				} else {
					this.addOrUpdateForm.index = index + 1
				}

			},
			remove(node, data) {
				var that = this
				this.$http({
						method: 'POST',
						url: this.url + '/update/state',
						data: {
							ids: [data.id],
							state: -1
						}
					})
					.then(function(res) {
						if (res.data.errorCode == '0000') {
							that.successMessage('操作成功', '删除成功！');
							const parent = node.parent;
							const children = parent.data.children || parent.data;
							const index = children.findIndex(d => d.id === data.id);
							children.splice(index, 1);
						}
					})

			},
			handleDrop(draggingNode, dropNode, dropType, ev) {
				draggingNode.parent = dropNode
				this.flushOrderBy()
			},
			flushOrderBy() {
				var menuOrder = {}
				this.fillOrderBy({
					children: this.data
				}, this.data, menuOrder)
				if (Object.keys(menuOrder).length > 0) {
					this.$http({
							method: 'POST',
							url: this.url + '/updateOrder',
							data: menuOrder
						})
						.then(function(res) {})
				}
			},
			fillOrderBy(parent, children, menuOrder) {
				if (children) {
					var index = 1
					children.forEach(item => {
						if (item.orderBy != index) {
							item.orderBy = index
							menuOrder[item.id] = {
								orderBy: index,
								parentId: parent.id
							}
						}
						this.fillOrderBy(item, item.children, menuOrder)
						index++
					})
				}
			},
			handleUpdate() {
				var that = this;
				that.addOrUpdateForm.parent = null
				that.addOrUpdateForm.children = null
				this.$refs['addOrUpdateForm'].validate(valid => {
					if (valid) {
						that.addOrUpdateForm.business = that.addOrUpdateForm.businessArray.join();
						that.addOrUpdateForm.permTypes = [];
						var url ='create'
						if(that.addOrUpdateForm.id){
							url ='update'
						}
						debugger
						this.$http({
								method: 'POST',
								url: that.url + '/'+url,
								data: that.addOrUpdateForm
							})
							.then(function(res) {
								if (res.data.errorCode == '0000') {
									var childLength = 1
									if (that.addOrUpdateForm.id) {
										that.selectNode.label = that.addOrUpdateForm.label
										that.selectNode.icon = that.addOrUpdateForm.icon
										that.selectNode.type = that.addOrUpdateForm.type
										that.selectNode.orderBy = that.addOrUpdateForm.orderBy
										that.selectNode.code = that.addOrUpdateForm.code
										that.selectNode.perUrl = that.addOrUpdateForm.perUrl
										that.selectNode.businessArray = that.addOrUpdateForm.businessArray
										that.selectNode.business = that.addOrUpdateForm.business
										that.selectNode.isShow = that.addOrUpdateForm.isShow
										that.selectNode.parentId = that.addOrUpdateForm.parentId
									} else {
										const newChild = {
											id: res.data.data,
											label: that.addOrUpdateForm.label,
											type: that.addOrUpdateForm.type,
											orderBy: that.addOrUpdateForm.orderBy,
											icon: that.addOrUpdateForm.icon,
											code: that.addOrUpdateForm.code,
											perUrl: that.addOrUpdateForm.perUrl,
											businessArray: that.addOrUpdateForm.businessArray,
											business: that.addOrUpdateForm.business,
											children: [],
											isShow:that.addOrUpdateForm.isShow,
											parentId:that.addOrUpdateForm.parentId,
										};
										var node = that.selectNode
										if (that.addOrUpdateForm.parentId == that.selectNode.parent.id) {
											node = that.selectNode.parent
										}
										if (!node.children) {
											that.$set(node, 'children', []);
										}
										newChild.parent = node
										node.children.splice(that.addOrUpdateForm.index, 0, newChild);
										childLength = node.children.length
									}
									that.dialogVisible = false;
									if (that.addOrUpdateForm.index != 0 && that.addOrUpdateForm.index != childLength - 1) {
										that.flushOrderBy()
									}

								}
							})
					}
				});
			},
		},
		beforeMount: function() {},
		mounted: function() {
			this.handleQueryParent();
			this.handleQueryTree();
			this.handlePreviewQueryTree();
		}
	}
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}

	.custom-tree-node {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding-right: 8px;
	}

	/deep/ .el-card__body {
		padding: 0px
	}
</style>


// WEBPACK FOOTER //
// src/view/system/menus.vue